import classNames from "classnames";
import { HTMLAttributes } from "react";
import ColorLegendScale from "./ColorLegendScale";
import ColorLegendCaption from "./ColorLegendCaption";
import styles from "./index.module.scss";

interface ColorLegendProps extends HTMLAttributes<HTMLElement> {
	caption: string;
}

const ColorLegend = ({
	className,
	children,
	...elementProps
}: ColorLegendProps) => {
	return (
		<figure
			{...elementProps}
			className={classNames(styles["color-legend-wrapper"])}
		>
			<ColorLegendScale />
			<ColorLegendCaption min={0} max={100} />
		</figure>
	);
};

export default ColorLegend;
